// extracted by mini-css-extract-plugin
module.exports = {"infoWrapper":"ClientEmergencyInfo_infoWrapper__-5RpU","itemTitle":"ClientEmergencyInfo_itemTitle__10uuE","itemText":"ClientEmergencyInfo_itemText__3Zk1Y"};